// The Last Lamp. Eight original pages with one true order.

const TITLE = "The Last Lamp";
const DEK = "Eight sheets from one evening. Put them back in order.";

const introParagraphs = [
  "These sheets tell one evening in the watch room. They are not in the order they happened.",
  "The sheet numbers belong to this printing only. The true order is not printed in this file.",
];

const PAGES = [
  { id: 1, text: "The watch room was locked at nine. Ida Pell turned the key and left the lamp burning. She dropped the key into her coat pocket and went down the stairs." },
  { id: 2, text: "At half past nine the key was still in that pocket. She was halfway down the stairs, coat on, when she heard glass break above her." },
  { id: 3, text: "The broken glass was the watch-room window, not the door. The door was still locked. The lamp she had left burning was out." },
  { id: 4, text: "She climbed in through the window. The tide table was gone from the desk. A wet boot print crossed the floor from the sill to the desk." },
  { id: 5, text: "The print was a left boot, and the heel had a nick in it. The only boot with that nick belonged to Tom Lin." },
  { id: 6, text: "Ida had cut the nick herself that afternoon, with a knife, so the print could be recognised. The cut was new, and it was full of fresh sand." },
  { id: 7, text: "Tom Lin had been sent to the jetty at nine to watch the tide. He was still standing there, and his feet were dry. He had not worn the nicked boot since Ida cut it that afternoon." },
  { id: 8, text: "Nell Carr passed him on the jetty and came up the path in his boots. The wet print in the watch room was hers. Tom's coat still hung by the door, with a dry pair of boots under it." },
];

function mulberry32(seed) {
  let a = seed >>> 0;
  return function () {
    a |= 0;
    a = (a + 0x6d2b79f5) | 0;
    let t = Math.imul(a ^ (a >>> 15), 1 | a);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

function caseLabel(seed) {
  return (seed >>> 0).toString(16).padStart(8, "0");
}

function pageById(id) {
  for (let i = 0; i < PAGES.length; i++) if (PAGES[i].id === id) return PAGES[i];
  return null;
}

function lead(page) {
  const text = pageById(page).text;
  const stop = text.indexOf(".");
  return stop > 0 ? text.slice(0, stop) : text;
}

function shuffleIds(seed) {
  const ids = PAGES.map(function (page) { return page.id; });
  const rand = mulberry32(seed);
  for (let i = ids.length - 1; i > 0; i--) {
    const j = Math.floor(rand() * (i + 1));
    const tmp = ids[i];
    ids[i] = ids[j];
    ids[j] = tmp;
  }
  const sorted = ids.every(function (id, index) { return id === index + 1; });
  if (sorted) return shuffleIds((seed + 1) >>> 0);
  return ids;
}

function createCase(seed) {
  const dealt = shuffleIds(seed >>> 0);
  return { version: 1, seed: seed >>> 0, dealt: dealt };
}

function sheetNumbers(dealt) {
  const sheets = [];
  for (let id = 1; id <= PAGES.length; id++) sheets.push(dealt.indexOf(id) + 1);
  return sheets;
}

function sameOrder(left, right) {
  if (!left || !right || left.length !== right.length) return false;
  for (let i = 0; i < left.length; i++) if (left[i] !== right[i]) return false;
  return true;
}

function trueOrder() {
  return PAGES.map(function (page) { return page.id; });
}

function assertCase(state) {
  if (!state || state.version !== 1 || !Array.isArray(state.dealt) || state.dealt.length !== 8) {
    throw new Error("The deal is incomplete");
  }
  const seen = {};
  state.dealt.forEach(function (id) {
    if (!pageById(id) || seen[id]) throw new Error("The deal is not eight pages");
    seen[id] = true;
  });
  if (sameOrder(state.dealt, trueOrder())) throw new Error("The deal is already in order");
  const again = createCase(state.seed);
  if (!sameOrder(again.dealt, state.dealt)) throw new Error("The deal is not fixed");
  const blob = PAGES.map(function (page) { return page.text; }).join(" ");
  if (/cluedo|murdle|holmes|watson|moriarty|jawbone|journal 29|alice|starling|wordle/i.test(blob)) {
    throw new Error("Reserved wording");
  }
}

function runSelfTest() {
  for (let seed = 1; seed <= 12; seed++) {
    const made = createCase(seed);
    assertCase(made);
    const sheets = sheetNumbers(made.dealt);
    if (sheets.length !== 8) throw new Error("Sheet numbers missing");
    const seen = {};
    sheets.forEach(function (n) {
      if (n < 1 || n > 8 || seen[n]) throw new Error("Sheet numbers repeat");
      seen[n] = true;
    });
  }
  const summary = "last lamp pages 8 seed1 " + caseLabel(1);
  if (typeof print === "function") print(summary);
  else console.log(summary);
}

if (typeof window === "undefined") runSelfTest();

globalThis.LastLamp = {
  TITLE: TITLE,
  DEK: DEK,
  introParagraphs: introParagraphs,
  PAGES: PAGES,
  caseLabel: caseLabel,
  pageById: pageById,
  lead: lead,
  createCase: createCase,
  sheetNumbers: sheetNumbers,
  sameOrder: sameOrder,
  trueOrder: trueOrder,
  assertCase: assertCase,
};
